import {
  CREATE_DUPLICATE_COMPONENT,
  DELETE_COMPONENT_REJECTED,
  DELETE_COMPONENT_REQUESTED,
  GET_IMAGE_SIZE_FOR_COMPONENT_FAILURE,
  GET_IMAGE_SIZE_FOR_COMPONENT_REQUEST,
  GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE,
  GET_EXISTING_COMPONENTS_FULLFILLED,
  GET_EXISTING_COMPONENTS_REQUESTED,
  GET_EXISTING_COMPONENTS_REJECTED,
  OPEN_COMPONENT_FOR_EDITING,
  OPEN_PARENT_COMPONENT_FOR_EDITING
} from './const';

/**
 * Returns action to request an existing component
 * @param {string} componentId - object containing component data.
 * @param {string} version - version for component.
 * @returns {object} action Object
 */
export const getExistingComponent = (componentId, version) => ({
  type: GET_EXISTING_COMPONENTS_REQUESTED,
  componentId,
  version
});

/**
 * Returns action to handle component request failure
 * @param {string} componentId - the id of the component
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const getExistingComponentFailure = (componentId, error) => ({
  type: GET_EXISTING_COMPONENTS_REJECTED,
  componentId,
  error
});

/**
 * Returns action to handle get component request failure
 * @param {string} componentId - the id of the component
 * @param {object} component - the response payload of the successful call
 * @returns {object} an action object
 */
export const getExistingComponentSuccess = (componentId, component) => ({
  type: GET_EXISTING_COMPONENTS_FULLFILLED,
  componentId,
  component
});

/**
 * Returns action to open component editor event
 * @param {object} component - the response payload of the successful call
 * @param {object} parentComponent - parent component cbject
 * @returns {object} an action object
 */
export const openComponentForEditing = (component, parentComponent) => ({
  type: OPEN_COMPONENT_FOR_EDITING,
  component,
  parentComponent
});

/**
 * Returns action to handle open parent component
 * @param {object} parentComponent - the parent component object
 * @returns {object} an action object
 */
export const openParentComponentForEditing = parentComponent => ({
  type: OPEN_PARENT_COMPONENT_FOR_EDITING,
  parentComponent
});

/**
 * Returns action to create a duplicate of an existing component
 * @param {object} component - duplicate component object
 * @returns {object} action Object
 */
export const createDuplicateComponent = component => ({
  type: CREATE_DUPLICATE_COMPONENT,
  component
});

/**
 * trigger a request to delete component
 * @returns {object} an action object
 */
export const deleteComponentRequest = () => ({
  type: DELETE_COMPONENT_REQUESTED
});

/**
 * handle delete component request failure
 * @param {Error} error - the error object describing the failure
 * @returns {object} an action object
 */
export const deleteComponentFailure = error => ({
  type: DELETE_COMPONENT_REJECTED,
  error
});

/**
 * action to handle image size request failure
 * @param {Error} error - error object
 * @returns {object} an action object
 */
export const getImageSizeFailure = error => ({
  type: GET_IMAGE_SIZE_FOR_COMPONENT_FAILURE,
  error
});

/**
 * action to request image size request
 * @param {string} componentId - id of the component
 * @param {Array} imageDetails - image details
 * @returns {object} an action object
 */
export const getImageSizeRequest = (componentId, imageDetails) => ({
  type: GET_IMAGE_SIZE_FOR_COMPONENT_REQUEST,
  componentId,
  imageDetails
});

/**
 * action to receive image size response
 * @param {string} componentId - id of the component
 * @param {Array} imageDetails - image details
 * @returns {object} an action object
 */
export const getImageSizeResponse = (componentId, imageDetails) => ({
  type: GET_IMAGE_SIZE_FOR_COMPONENT_RESPONSE,
  id: componentId,
  value: imageDetails,
  schemaField: 'ContentSize'
});
